jest.mock('../Triggers');
jest.mock('../Steps');

import { Logger } from '@samelogic/steps';
import { WorkflowManager } from './WorkflowManager';
import { TriggerManager } from '../Triggers';
import { StepContainerManager } from '../Steps';
import { mock, MockProxy } from 'jest-mock-extended';
import { PackageMemoryCache } from '../Steps/Repository/PackageMemoryCache';
import { WorkflowConfig } from '../../models';
import { contextFactory, workflowFactory } from '../__tests__/factories';
import { Context } from '../Context/Context';
import { EventLogger } from '../../tracking/EventLogger';

const mockedTriggerManager = <jest.Mock<TriggerManager>>TriggerManager;
const mockedStepContainerManager = <jest.Mock<StepContainerManager>>StepContainerManager;

beforeEach(() => {
  mockedStepContainerManager.mockClear();
  mockedTriggerManager.mockClear();
});

describe('WorkflowManager', () => {
  let workflowManager: WorkflowManager;
  let workflowConfig: WorkflowConfig;
  let workflowContext: Context;
  let packageMemoryCacheMock: MockProxy<PackageMemoryCache>;
  let loggerMock: MockProxy<Logger>;
  let eventLoggerMock: MockProxy<EventLogger>;

  beforeEach(() => {
    workflowConfig = workflowFactory.build();
    workflowContext = contextFactory.build();
    packageMemoryCacheMock = mock<PackageMemoryCache>();
    loggerMock = mock<Logger>();
    eventLoggerMock = mock<EventLogger>();

    workflowManager = new WorkflowManager(
      workflowContext,
      workflowConfig,
      packageMemoryCacheMock,
      loggerMock,
      eventLoggerMock
    );
  });

  describe('start()', () => {
    let mockTriggerManagerInstance: TriggerManager;
    let mockStepContainerManagerInstance: StepContainerManager;
    beforeEach(() => {
      mockTriggerManagerInstance = mockedTriggerManager.mock.instances[0];
      mockStepContainerManagerInstance = mockedStepContainerManager.mock.instances[0];
      workflowManager.start();
    });
    it('should start the TriggerManager', () => {
      expect(mockTriggerManagerInstance.start).toBeCalled();
    });
    describe('when trigger is fired', () => {
      beforeEach(() => {
        mockTriggerManagerInstance.onTriggered?.();
      });
      it('should start the StepContainerManager', () => {
        // TODO: test that start is called with context.trigger event.
        expect(mockStepContainerManagerInstance.start).toBeCalled();
      });
    });
  });
});
